import React, { Component,useImperativeHandle,useRef,useState } from "react";
import { v4 as uuid } from "uuid";

import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate } from "react-router-dom";
import store from "@/redux/store";

import * as CustomerConst from "actions/customerConst";
import {FieldHolder} from "@/components/holders/FieldHolder";
import {Address} from "@/views/base/address/Address";
import  {ICustomer} from "@/models/Customer";

import { Vat } from "@/views/base/company/Vat";
import { Contact } from "../contact/Contact";
import { ContactPanel } from "../contact/ContactPanel";

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { WINDOW } from "@/actions/globalConst";
import { open } from "@/reducers/Window";
import { AddressEditView } from "@/controllers/Base/View/AddressEditView";


export function Detail({...props}) {
  const addressRef = useRef(null);
    let currentExternTenant = null;
let index = 0;
let registerKey = props.registerkey;
let register = props.register
let fieldData = props.data;
if(props?.externTenants) {
props?.externTenants.map((tenant) => {
    if(fieldData?.db == tenant.id) {
        currentExternTenant = tenant;
    }
});
}

  useImperativeHandle(props?.ref, () => {
    return {
        getData() {
          // let cusmterObj = props.getValues();
          // 
          // let addresses = cusmterObj?.addresses;
          // 
//          addresses.update(0, addressRef.current.testme());
          //props?.setValue('address.0', addressRef.current.testme());
          // console.debug("addres ref", addressRef.current.testme());
            // return addressRef.current.testme();
        }
      // ... your methods ...
    };
  }, []);



    const [selectedTab, setSelectedTab] = useState(1);
    const [externTenant, setExternTenant] = useState({...currentExternTenant});


  const onSaveWrapped = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    
//props.onSaveHandler(value);
return false;
    store.dispatch({
      type: "t",
      data: value,
    });


    return false;
  };

function selectCustomerTab(event, tabId) {
    setSelectedTab(tabId);
}
function addAddress(event) {
    event.preventDefault();
    event.stopPropagation();

console.debug("addres ref", addressRef.current.testme());

//    store.dispatch( open({...WINDOW.ADDRES_WINDOW}) );
    return false;
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const tabs = [
  {id:1, name: 'Algemene gegevens', href: '#', current: true },
  {id:2, name: 'KvK & BTW', href: '#', current: false },
  {id:3, name: 'Contact', href: '#', current: false },
  {id:4, name: 'Overige', href: '#', current: false },
]

const changeExternTenant=(data) => {
    if(props.setFormValues) {
        props.setFormValues("tenant.db", data.id);
    }
    setExternTenant(data);
}

  return (
    <>






                <div className="grid grid-cols-12 gap-1">
                    <div className="col-span-12 sm:col-span-8">
            <FieldHolder colspan="12" smcolspan="5" label="Bedrijfsnaam" id="name" error={props?.state?.error}>
                  <input
                    id="name"
                    type="text"
                    {...register(registerKey+"name" )}
                    key={(fieldData && fieldData["name"]) ?? null}

                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                  {props?.externTenants &&
    <Listbox onChange={changeExternTenant}>
      <Label className="block text-sm font-medium leading-6 text-gray-900">Koppel met externe database</Label>
      <div className="relative mt-2">
       <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
            {externTenant && <span className="block truncate"><span className="px-2 bg-gray-100 rounded-md mr-2 py-1">{externTenant.name} ({externTenant.label})</span></span>}
          {!externTenant && <span className="block truncate text-gray-400">Selecteer</span>}
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
          </span>
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >

          {props?.externTenants && props?.externTenants.map((tenant) => {
              return (<Listbox.Option
              key={tenant.id}
              value={tenant}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
              data-active={fieldData?.db == tenant.id}
            >
              <span className="block truncate font-normal group-data-[active=true]:font-semibold">{tenant.name} ({tenant.label})</span>

              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-active=true])_&]:hidden">
                <CheckIcon aria-hidden="true" className="h-5 w-5" />
              </span>
            </Listbox.Option>)
          })}
        </ListboxOptions>
      </div>
    </Listbox>
                }


            </FieldHolder>
                  </div>
                  <div className="col-span-12 sm:col-span-12">

                  <div className="pt-5 ">
   <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.id == selectedTab).name}
          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href="#"
                aria-current={tab.current ? 'page' : undefined}
                className={classNames(
                  tab.id == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700',
                  'flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
                )}
                onClick={(event) => selectCustomerTab(event, tab.id)}
              >
                {tab.name}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>

                  </div>

                  {selectedTab == 1 && props.data && ((props?.selected?.addresses && props?.selected?.addresses.length > 0) )  &&
                    <>
                    <button onClick={(event) => addAddress(event)}>Address</button>
                    <AddressEditView key={uuid().slice(0, 8)} ref={addressRef} getValues={props.getValues}/>
                    </>
                    }
                  {selectedTab == 2 &&
                    <Vat key={"vatPanel"} registerkey={registerKey+``} data={props.data} state={props.state} register={register} />
                    }
                  {selectedTab == 3 && (props?.externTenants == null) &&
                    <Contact key={fieldData.key+registerKey+`contact.items.${index}.phone`} registerkey={registerKey+`contact.items.${index}.`} data={fieldData.contact.first()}  index={index} state={props.state} register={register} />
                    }
                    {selectedTab == 3 && props?.externTenants &&
                      <ContactPanel data={props?.selected} state={props.state} settings={props?.settings} />
                      }

                </div>
              </div>

    </>
      );
}